import React, { useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { Security } from "@okta/okta-react";
import { OktaAuth } from '@okta/okta-auth-js';
import { ToastContainer } from "react-toastify";
import { SetOktaIssuer } from "./Utils/Utils";
import { ABOUT, CONTACT_US, DAILY_VIEW, DASHBOARD, LIST_VIEW, LOGIN, LOGIN_CALLBACK, MONTHLY_VIEW, SEARCH_INFO, TRAINING, WEEKLY_VIEW } from './Utils/Constants';
import ReactGA from "react-ga4";
import Dashboard from './Pages/Dashboard/Index';
import About from './Pages/About/Index';
import ContactUs from './Pages/ContactUs/Index';
import ListView from './Pages/ListView/Index';
import Training from './Pages/Training/Index';
import Login from './Components/Login/Login';
import DailyView from './Pages/ViewMode/DailyView/Index';
import WeeklyView from './Pages/ViewMode/WeeklyView/Index';
import MonthlyView from './Pages/ViewMode/MonthlyView/Index';
import LoginVerify from "./Components/Login/LoginVerify";
import SearchInfo from "./Pages/SearchInfo/Index";
import { authClient } from "./Utils/Common";

function App() {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.replace(originalUri);
  };
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, [window.location]);
  return (
    <div className="App">
      <Router>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Security oktaAuth={authClient} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path={LOGIN} element={<Login />} />
            <Route path={DASHBOARD} element={<Dashboard />} />
            <Route path={LIST_VIEW} element={<ListView />} />
            <Route path={ABOUT} element={<About />} />
            <Route path={TRAINING} element={<Training />} />
            <Route path={CONTACT_US} element={<ContactUs />} />
            <Route path={WEEKLY_VIEW} element={<WeeklyView />} />
            <Route path={DAILY_VIEW} element={<DailyView />} />
            <Route path={MONTHLY_VIEW} element={<MonthlyView />} />
            <Route path={LOGIN_CALLBACK} element={<LoginVerify />} />
            <Route path={SEARCH_INFO} element={<SearchInfo />} />

          </Routes>
        </Security>
      </Router>
    </div>
  );
}
export default App;